export const fr = {
    titreOnglet: "Détail du compte | Desjardins",
    titreOngletMobile: "Détail du compte"
};
